import { rufe } from './client';

/**
 * Die Warteliste je Training (BUC-11, DAT-21 nach ÄA-55).
 *
 * Ein Eintrag nennt eine E-Mail-Adresse, ein Training, Plätze und einen
 * Zeitraum. Er hält keinen Platz: Wird an einem passenden Termin einer frei,
 * schickt der Server von selbst eine Mail mit Buchungslink. Diese Maske
 * zeigt, trägt ein und löscht.
 */

export const ZEITRAEUME_WOCHEN = [4, 8, 12] as const;
export type Zeitraum = (typeof ZEITRAEUME_WOCHEN)[number];

export type Wartelisteneintrag = {
  readonly id: string;
  readonly email: string;
  readonly artikel: string;
  readonly produkt: string;
  readonly plaetze: number;
  readonly wochen: Zeitraum;
  readonly anrede: string | null;
  readonly name: string | null;
  readonly herkunft: 'portal' | 'innendienst' | 'ueberfuehrt';
  readonly eingetragenAm: string;
  /** Ausschließlich: Ab diesem Zeitpunkt ist der Eintrag beendet. */
  readonly gueltigBis: string;
  /** `null`: Die Bestätigung per Link steht aus. */
  readonly bestaetigtAm: string | null;
  readonly zuletztBenachrichtigtAm: string | null;
  readonly benachrichtigungen: number;
};

/** Am Termin: wie viele bestätigte Einträge zu ihm passen. */
export type StandAmTermin = {
  readonly eintraege: number;
  readonly plaetze: number;
  readonly benachrichtigt: number;
};

export type Eintragung = {
  readonly email: string;
  readonly produkt: string;
  readonly plaetze: number;
  readonly wochen: Zeitraum;
  readonly anrede?: string;
  readonly name?: string;
};

export async function liste(artikel: string): Promise<readonly Wartelisteneintrag[]> {
  return rufe(`/artikel/${artikel}/warteliste`);
}

export async function amTermin(termin: string): Promise<StandAmTermin> {
  return rufe(`/termine/${termin}/warteliste`);
}

/** Die Bestätigungsmail geht auch bei der Eintragung im Innendienst hinaus. */
export async function eintragen(eingabe: Eintragung): Promise<{ readonly id: string }> {
  return rufe('/warteliste', { verfahren: 'POST', rumpf: eingabe });
}

export async function loeschen(eintrag: string): Promise<void> {
  await rufe(`/warteliste/${eintrag}`, { verfahren: 'DELETE' });
}
